import { render } from "./SzDialogStaff.vue?vue&type=template&id=63111a51&scoped=true"
import script from "./SzDialogStaff.vue?vue&type=script&lang=ts"
export * from "./SzDialogStaff.vue?vue&type=script&lang=ts"

import "./SzDialogStaff.vue?vue&type=style&index=0&id=63111a51&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-63111a51"

export default script